import React, { Component } from "react";
import { Link } from "react-router-dom";

import settings from "../../settings.js";

import Horn from "../../assets/horn.svg";
import Loader from "../../assets/loader.png";
import Scrollbars from "react-custom-scrollbars";

class Dashprods extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: true, data: [] };
  }
  componentDidMount() {
    this.loadData();
  }

  loadData(reset) {
    let page = 0;
    if (reset) {
      this.setState({ data: [], page: 0 });
    } else {
      page = this.state.page;
    }

    const loadpromo = this.props.promo;
    const loadnew = this.props.newproducts;

    if (!this.state.isLoading) {
      //console.log(this.state, this.props);
      this.setState({ isLoading: true });
      fetch(
        settings.server_url +
          "get_products/" +
          window.sessionStorage.getItem("sid"),
        {
          method: "POST",
          body: JSON.stringify({
            promo: loadpromo,
            new: loadnew,
            page: page,
            sessionID: 10,
          }),
        }
      )
        .then((res) => res.json())
        .then((response) => {
          let products = [...this.state.data, ...response];
          this.setState({ data: products, page: page + 1, isLoading: false });
        })
        .catch((error) => console.error("Error:", error));
    }
  }

  render() {
    return (
      <div className="gridItem ad">
        <div className="gridHeader">
          <div className="gridHeaderIcon">
            <img src={Horn} alt="" />
          </div>
          <div className="gridHeaderTitle">
            {this.props.promo ? "Aanbiedingen" : "Nieuwe producten"}
          </div>
          <div className="gridHeaderAll">
            <Link to={"/nieuwe-producten"} className="">
              Bekijk alle
            </Link>
          </div>
        </div>
        {this.state.isLoading ? (
          <Scrollbars style={{ height: 272 }}>
            <div className="gridRows loading"></div>
          </Scrollbars>
        ) : this.state.data.length > 0 ? (
          <Scrollbars style={{ height: 272 }}>
            <div className="gridRows">
              {this.state.data.map((notification, index) => (
                <div></div>
              ))}
            </div>
          </Scrollbars>
        ) : (
          <Scrollbars style={{ height: 272 }}>
            <div className="gridRows">
              <div></div>
            </div>
          </Scrollbars>
        )}
      </div>
    );
  }
}
Dashprods.defaultProps = {
  promo: false,
  newproducts: false,
};
export default Dashprods;
